module.exports = __webpack_public_path__ + "img/洛阳万众吉利热电厂.0072c80f.jpg";